import PropTypes from 'prop-types';
import React from 'react';

export default class extends React.Component {
    static displayName = 'PencilSvg';

    static propTypes = {
        pathClassName: PropTypes.string
    };

    render() {
        const { pathClassName } = this.props;
        return (
            <svg width="11px" height="11px" viewBox="0 0 11 11">
                <path className={pathClassName} d="M10.5,5.5 L0.5,5.5" ></path>
                <path className={pathClassName} d="M5.5,0.5 L5.5,10.5" ></path>
            </svg>
        );
    }
}